import actions from "./actions";

const initState = {
  users: [],
  menuCategories: [],
  reloadUsers: false,
  allAccess: [],
};

export default function usersReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_MENU_CATEGORIES_SUCCESS:
      return {
        ...state,
        menuCategories: action.menuCategories,
      };

    case actions.GET_CODE_REQUEST: {
      return {
        ...state,
        user: action.email,
      };
    }

    case actions.CHANGE_PASSWORD_REQUEST: {
      return {
        ...state,
        user: action.user,
      };
    }

    case actions.GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
      };

    case actions.UPDATE_USER_SUCCESS:
      return {
        ...state,
        reloadUsers: !state.reloadUsers,
      };

    case actions.DELETE_USER_SUCCESS:
      return {
        ...state,
        reloadUsers: !state.reloadUsers,
      };

    case actions.GET_ALL_ACCESS_SUCCESS:
      return {
        ...state,
        allAccess: action.allAccess,
      };

    default:
      return state;
  }
}
